import { render, staticRenderFns } from "./CostBreakdown.vue?vue&type=template&id=b8e1d9d2&scoped=true"
import script from "./CostBreakdown.vue?vue&type=script&lang=js"
export * from "./CostBreakdown.vue?vue&type=script&lang=js"
import style0 from "./CostBreakdown.vue?vue&type=style&index=0&id=b8e1d9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e1d9d2",
  null
  
)

export default component.exports